module.exports = __webpack_public_path__ + "static/media/011_JuergenKrause_webfinal.bbeb12b3.jpg";